(() => {
  const INTERNAL_HOSTS = new Set([
    'godshotstudio.myshopify.com',
    'mgsuk.myshopify.com',
    'mygodshot.com',
    'www.mygodshot.com',
  ]);

  function normalizeProductLinks(root = document) {
    root.querySelectorAll('.product__short-description a[target="_blank"]').forEach((link) => {
      const rawHref = link.getAttribute('href');

      if (!rawHref) return;

      let url;
      try {
        url = new URL(rawHref, window.location.href);
      } catch (_error) {
        return;
      }

      if (rawHref.startsWith('#') || rawHref.startsWith('/') || INTERNAL_HOSTS.has(url.hostname.toLowerCase())) {
        link.removeAttribute('target');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => normalizeProductLinks());
  } else {
    normalizeProductLinks();
  }

  document.addEventListener('shopify:section:load', (event) => normalizeProductLinks(event.target));
})();
